import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Map } from 'immutable';
import { Dropdown } from 'react-bootstrap';
import appConfig from '../../appConfig';
import { showMainDialog } from '../../actions/mainUI';
import { MODAL_VIEW_TYPE_DOWNLOAD, MODAL_VIEW_TYPE_DYNAMIC_DOWNLOAD }
  from '../../constants/mainContentTypes';
import { downloadURL } from '../../utils/umoUtils';

/* Dynamic Download Codes:
   DYNDW is smart check (batch or immediate dynamic)
   DYNQ is always batch (ask for email)
   DYN is always dyn create (no email as immediate)
*/

/* eslint-disable no-underscore-dangle */
const UMODownloadView = ({ umo, isRestricted, itemClass, dispatch, intl }) => {
  const onDownload = (e) => {
    const url = e.target.dataset.keyval;
    const isDynamic = e.target.dataset.keydynamic;
    const fileName = e.target.dataset.keyfilename;
    if (appConfig.downloadPurposeFields) {
      dispatch(showMainDialog(MODAL_VIEW_TYPE_DOWNLOAD,
        { umoID: umo.id, name: umo.name, fileName, url, isDynamic, type: umo.type }));
    } else if (isDynamic && isDynamic === 'DYNQ') {
      dispatch(showMainDialog(MODAL_VIEW_TYPE_DYNAMIC_DOWNLOAD,
        { umoID: umo.id, name: umo.name, fileName, url, isDynamic }));
    } else downloadURL(url, umo.name, fileName, dispatch, isDynamic);
  };

  let downloads;

  if (umo && umo.originalList && umo.originalList.all &&
    umo.originalList.all.length > 0 && !isRestricted) {
    downloads = umo.originalList.all.map((downloadData, i) =>
      <Dropdown.Item
        className={itemClass}
        key={i}
        data-keyval={downloadData.url}
        data-keydynamic={downloadData.downloadCode}
        data-keyfilename={downloadData.fileName}
        onClick={onDownload}
      >
        {downloadData.name}
      </Dropdown.Item>
    );
  } else {
    downloads = (
      <Dropdown.Item className={itemClass} disabled>
        {intl.formatMessage({ id: 'umoGridItem.menuNoDownloadsAvailableMessage' })}
      </Dropdown.Item>);
  }

  return (downloads);
};

UMODownloadView.propTypes = {
  umoUtils: PropTypes.instanceOf(Map),
  hideDialog: PropTypes.func,
  dispatch: PropTypes.func,
  data: PropTypes.instanceOf(Object),
};

export default injectIntl(UMODownloadView);

